import { useEffect } from 'react';
import { focusOnDefault } from '../../../../../shared/actions/window';
import getPdfViewerApplication from '../../../../utils/pdfjs/pdfViewerApplication';
import PanelTypeConfig from '../../panel/panelTypeConfig';
import usePrevious from './usePrevious';

export default function useResetViewerHighlights(panels) {
  const supportsViewerHighlights = panels.some((panel) => {
    const config = PanelTypeConfig[panel.type];
    return config.supportsViewerHighlights;
  });

  const previouslySupportedViewerHighlights = usePrevious(supportsViewerHighlights);

  const shouldResetHighlights = previouslySupportedViewerHighlights && !supportsViewerHighlights;

  const restoreFocus = panels.length === 0;

  useEffect(() => {
    if (shouldResetHighlights) {
      const { enhancementManager } = getPdfViewerApplication();
      enhancementManager.clearActive({
        restoreFocus,
        restoreFocusFallback: focusOnDefault,
      });
    }
  }, [shouldResetHighlights, restoreFocus]);
}
